import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as commonStyles from '../../../common/_common.scss'
import AdviserProfileEducation from '../../../common/AdviserProfiles/AdviserProfileEducation'
import EditButton from '../../../common/forms/EditButton'
import DeleteButton from '../../../common/forms/DeleteButton'
import AdviserQualificationEditor from './AdviserQualificationEditor'
import * as styles from './_AdviserProfileEducationEditor.scss'
import { Modal } from 'react-bootstrap'
import PrimaryActionButton from '../../../common/Buttons/PrimaryActionButton'
import SecondaryActionButton from '../../../common/Buttons/SecondaryActionButton'
import { connect } from 'react-redux'
import { actions } from './adviserProfileEducationEditorActions'
import { bindActionCreators } from 'redux'

class adviserProfileEducationEditor extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    validationstate: PropTypes.object.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    editingProfile: PropTypes.bool.isRequired,

    setAddNewQualification: PropTypes.func.isRequired,
    setStartEditingQualification: PropTypes.func.isRequired,
    setStopEditingQualification: PropTypes.func.isRequired,
    setCancelEditingQualification: PropTypes.func.isRequired,
    setQualification: PropTypes.func.isRequired,
    setQualificationStudyStartMonth: PropTypes.func.isRequired,
    setQualificationStudyStartYear: PropTypes.func.isRequired,
    setQualificationStudyEndMonth: PropTypes.func.isRequired,
    setQualificationStudyEndYear: PropTypes.func.isRequired,
    setQualificationStudyEndDateCurrent: PropTypes.func.isRequired,
    setDeleteQualificationModal: PropTypes.func.isRequired,
    deleteQualification: PropTypes.func.isRequired,
    setDeletingQualificationCancel: PropTypes.func.isRequired,

    loadingEducation: PropTypes.bool.isRequired,
    editingQualification: PropTypes.bool.isRequired,
    editingQualificationIndex: PropTypes.number.isRequired,
    deletingQualificationModal: PropTypes.bool.isRequired,
    deletingQualificationIndex: PropTypes.number.isRequired,
    studyStartMonth: PropTypes.number,
    studyStartYear: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    studyEndMonth: PropTypes.number,
    studyEndYear: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ])
  }

  renderPreview () {
    const profile = this.props.profile
    const children = (profile.qualifications || []).map((qualification, index) => {
      return <span key={index}>
        <EditButton
          editing={this.props.editingQualification}
          startEditing={() => {
            this.props.setStartEditingQualification(index)
          }} />
        |
        <DeleteButton
          startDeleting={() => {
            this.props.setDeleteQualificationModal(index)
          }} />
      </span>
    })

    return <div className={styles['modal-container']}>
      <AdviserProfileEducation qualifications={profile.qualifications || []} className={styles['no-bottom-padding']} >
        {this.props.editingProfile ? children : null}
      </AdviserProfileEducation>
      {this.props.editingProfile && <a className={styles['add-education-button']} onClick={() => {
        this.props.setAddNewQualification()
      }} target='blank'>Add a qualification to your profile</a>}
      <Modal
        show={this.props.deletingQualificationModal}
        aria-labelledby='contained-modal-title' >
        <Modal.Header style={{ borderBottom: 'none', paddingLeft: '40px', paddingRight: '40px', paddingTop: '40px' }}>
          <h2>Deleting qualification</h2>
        </Modal.Header>
        <Modal.Body style={{ paddingLeft: '40px', paddingRight: '40px' }}>
          <p>Are you sure you wish to delete the {this.props.deletingQualificationIndex !== -1 ? this.props.profile.qualifications[this.props.deletingQualificationIndex].description : ''}?</p>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: 'none', paddingLeft: '40px', paddingRight: '40px', paddingBottom: '40px' }}>
          <PrimaryActionButton
            className={commonStyles['delete-confirmation-modal-button']}
            buttonText='Delete'
            onClick={() => {
              this.props.deleteQualification()
            }}
          />
          <SecondaryActionButton
            buttonText='Cancel'
            onClick={() => {
              this.props.setDeletingQualificationCancel()
            }}
          />
        </Modal.Footer>
      </Modal>
    </div>
  }

  renderEditor () {
    return <AdviserProfileEducation
      qualifications={this.props.profile.qualifications || []}
      editor
      editingIndex={this.props.editingQualificationIndex} className={styles['no-bottom-padding']} >
      {(this.props.profile.qualifications || []).map((qualification, index) => {
        if (this.props.editingQualificationIndex === index) {
          return <AdviserQualificationEditor
            key={index}
            formIsValid={this.props.formIsValid}
            qualification={qualification}
            editingQualification={this.props.editingQualification}
            validationstate={this.props.validationstate}
            stopEditingQualification={() => {
              this.props.setStopEditingQualification()
            }}
            cancelEditingQualification={() => {
              this.props.setCancelEditingQualification()
            }}
            descriptionHandleChange={(validationResult, value) => {
              this.props.setQualification(validationResult, {
                description: value,
                institution: qualification.institution,
                studyEndDate: qualification.studyEndDate,
                studyStartDate: qualification.studyStartDate
              })
            }}
            institutionHandleChange={(validationResult, value) => {
              this.props.setQualification(validationResult, {
                description: qualification.description,
                institution: value,
                studyEndDate: qualification.studyEndDate,
                studyStartDate: qualification.studyStartDate
              })
            }}
            dateHandleChange={() => {
              let validationResult = {
                description: this.props.validationstate.description,
                institution: this.props.validationstate.institution
              }
              this.props.setQualification(validationResult, {
                description: qualification.description,
                institution: qualification.institution,
                studyStartDate: qualification.studyStartDate,
                studyEndDate: qualification.studyEndDate
              })
            }}
            studyStartMonth={this.props.studyStartMonth}
            studyStartYear={parseInt(this.props.studyStartYear)}
            studyEndMonth={this.props.studyEndMonth}
            studyEndYear={parseInt(this.props.studyEndYear)}
            handleStudyStartMonth={(validationResult, value) => {
              this.props.setQualificationStudyStartMonth(validationResult, value)
            }}
            handleStudyStartYear={(validationResult, value) => {
              this.props.setQualificationStudyStartYear(validationResult, value)
            }}
            handleStudyEndMonth={(validationResult, value) => {
              this.props.setQualificationStudyEndMonth(validationResult, value)
            }}
            handleStudyEndYear={(validationResult, value) => {
              this.props.setQualificationStudyEndYear(validationResult, value)
            }}
            handleCurrentEndYear={() => {
              this.props.setQualificationStudyEndDateCurrent()
            }}
          />
        }
      })}
    </AdviserProfileEducation>
  }

  render () {
    if (this.props.editingQualification && this.props.editingProfile) {
      return this.renderEditor()
    }

    return this.renderPreview()
  }
}

const mapStateToProps = ({ adviserProfileEditorContainer }) => {
  return {
    loadingEducation: adviserProfileEditorContainer.education.loadingEducation,
    editingQualification: adviserProfileEditorContainer.education.editingQualification,
    editingQualificationIndex: adviserProfileEditorContainer.education.editingQualificationIndex,
    deletingQualificationModal: adviserProfileEditorContainer.education.deletingQualificationModal,
    deletingQualificationIndex: adviserProfileEditorContainer.education.deletingQualificationIndex,
    studyStartMonth: adviserProfileEditorContainer.education.studyStartMonth,
    studyEndMonth: adviserProfileEditorContainer.education.studyEndMonth,
    studyStartYear: adviserProfileEditorContainer.education.studyStartYear,
    studyEndYear: adviserProfileEditorContainer.education.studyEndYear,
    formIsValid: adviserProfileEditorContainer.education.isInvalid.formIsValid,
    validationstate: adviserProfileEditorContainer.education.isInvalid,
    allEducation: adviserProfileEditorContainer.education.allEducation
  }
}

const mapDispatchToProps = (dispatch) => {
  const { add, edit, set, deletes } = actions
  return bindActionCreators({
    setAddNewQualification: add.qualification,
    setStartEditingQualification: edit.start,
    setStopEditingQualification: edit.stop,
    setCancelEditingQualification: edit.cancel,
    setQualification: set.qualification,
    setQualificationStudyStartMonth: set.startMonth,
    setQualificationStudyStartYear: set.startYear,
    setQualificationStudyEndMonth: set.endMonth,
    setQualificationStudyEndYear: set.endYear,
    setQualificationStudyEndDateCurrent: set.endDateCurrent,
    setDeleteQualificationModal: deletes.modal,
    deleteQualification: deletes.qualification,
    setDeletingQualificationCancel: deletes.cancel
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileEducationEditor))
